import RestService from "./RestService";
import { ApiRoutes } from "./apiRoutes";

export const ConstraintsService = {
  searchMicroCategories: async (
    microCategorySearchString: string,
  ): Promise<any[]> => {
    return RestService.get(
      ApiRoutes.SEARCH_MICROCATEGORIES(microCategorySearchString),
    );
  },
  searchProducts: async (productSearchString: string): Promise<any[]> => {
    return RestService.get(ApiRoutes.SEARCH_PRODUCTS(productSearchString));
  },

  async getMicrocategoryNames(): Promise<Record<string, string>> {
    return RestService.get(ApiRoutes.MICROCATEGORY_NAMES);
  },

  async getProductNames(isins: string[]): Promise<Record<string, string>> {
    return RestService.get(ApiRoutes.PRODUCT_NAMES(isins));
  },
  async fetchConstraintsDefault(): Promise<any> {
    return RestService.get(ApiRoutes.CONSTRAINTS_DEFAULT);
  },
  fetchPtf: async (portfolioData: any): Promise<any> => {
    return RestService.post(ApiRoutes.PTF_THREAD, {
      portfolio_data: portfolioData,
    });
  },
};
